import React, { useEffect, useRef, useState } from "react";
import { Box, SpanStyled } from "../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import {
  NavSidebarWrapper,
  ProfileBannerWrapper,
  ProfileContent,
  ProfileWrapper,
} from "./styled";
import { settingsTabsList, tabsArrayList } from "./TabsArray";
import { Link, useNavigate } from "react-router-dom";
import BannerImage from "./components/BannerImage";
import ProfileImageUpload from "./components/ProfileImageUpload";
import {
  ChangePasswordSidebarList,
  ProfileSidebarList,
} from "../../../helpers/webConstants";
import ChangePasswordForm from "./ChangePasswordForm";
import ProfileApi from "../../../services/api/profileApi";
import { toast } from "react-toastify";
import UpdateCoverImage from "./components/UpdateCoverImage";
import { useUser } from "../../../context/userContext";
import { Form } from "react-bootstrap";

const ChangePassword = () => {
  const { t } = useTranslation();
  const { fetchUserInfo } = useUser();
  const sidebarRef = useRef();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(settingsTabsList[0]);
  const [isVisible, setIsVisible] = useState(window.innerWidth >= 992);
  useEffect(() => {
    const handleResize = () => {
      setIsVisible(window.innerWidth >= 992);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.addEventListener("resize", handleResize);
    };
  }, []);
  const updateProfileOrCover = async (dataObj) => {
    try {
      const formData = new FormData();
      Object.entries(dataObj).forEach(([key, value]) => {
        formData.append(key, value);
      });
      const { message, code } = await ProfileApi.updateProfileOrCover(formData);
      if (code === 200) {
        toast.success(message);
        fetchUserInfo();
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {}
  };

  return (
    <ProfileWrapper>
      <ProfileBannerWrapper>
        <UpdateCoverImage
          cameraImage={false}
          handleCoverUpdate={updateProfileOrCover}
        />
        <Box className="profileContentWrapper justify-content-center">
          <ProfileImageUpload
            cameraImage={false}
            handleImageUpload={updateProfileOrCover}
          />
        </Box>
      </ProfileBannerWrapper>
      <Box className="profileContainer">
        {isVisible && (
          <NavSidebarWrapper className={`SideBar`} ref={sidebarRef}>
            <Box className="text-center">
              <Box className="sidebar-list custom-scroll">
                <ul className="list-unstyled mb-0 pt-3">
                  {ChangePasswordSidebarList.map((item, key) => {
                    return (
                      <li key={item.title + key} className={`mb-2`}>
                        <Link
                          className={`text-decoration-none d-flex align-items-center justify-content-between ${
                            item.title === activeTab.title ? "active" : ""
                          }`}
                          onClick={() => setActiveTab(settingsTabsList[key])}
                          // onClick={() => navigate(item.url)}
                          // to={item.url}
                        >
                          <Box className="d-flex align-items-center gap-2">
                            <Box className="list-icon">
                              <item.icon />
                            </Box>
                            <Box>
                              <SpanStyled
                                className="text-capitalize d-flex"
                                style={{ textAlign: "start" }}
                              >
                                {t(item.title)}
                              </SpanStyled>
                            </Box>
                          </Box>
                          {item?.switch && (
                            <Form.Check
                              type="switch"
                              className="custom-switch"
                              onClick={(e) => e.stopPropagation()}
                            />
                          )}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </Box>
            </Box>
          </NavSidebarWrapper>
        )}
        <ProfileContent>
          <activeTab.component />
        </ProfileContent>
      </Box>
    </ProfileWrapper>
  );
};

export default ChangePassword;
